import React from "react";
import {
  NotificationWrapper,
  NotificationImage,
  NotificationTitle,
  NotificationCard,
  NotificationTime,
} from "./notificationStyles.js";

export const Notification = (props) => {
  if (!props.notification || props.notification.text.length === 0 || props.notification.type.length === 0)
    return <React.Fragment />;
  return (
    <NotificationWrapper duration={props.duration} key={props.notification.id}>
      <NotificationCard>
        <NotificationImage fileName={props.notification.image.length > 1 ? props.notification.image : null} />
        <NotificationTitle>{props.notification.type}</NotificationTitle>
        <p>{props.notification.text}</p>
        <NotificationTime>{props.timeLabel}</NotificationTime>
      </NotificationCard>
    </NotificationWrapper>
  );
};
